import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=3dcace1e&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=3dcace1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcace1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcace1e')) {
      api.createRecord('3dcace1e', component.options)
    } else {
      api.reload('3dcace1e', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=3dcace1e&scoped=true&", function () {
      api.rerender('3dcace1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/Avatar.vue"
export default component.exports